import { FallbackIcon } from '../../FallbackIcon';
import { S } from './SVGIcon.styles';
import type { SVGIconProps } from './SVGIcon.types';

const PlaceholderIcon = () => <FallbackIcon data-cy="icon-not-ready" width="100%" height="100%" />;

export const SVGIcon = ({ title, src, ...otherProps }: SVGIconProps) => (
  <S.StyledReactSvg
    src={src}
    wrapper="svg"
    fallback={PlaceholderIcon}
    loading={PlaceholderIcon}
    aria-hidden
    {...otherProps}
  />
);
